import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UserDataContext } from "context";
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios";
import TailwindLayout from "TailwindcssComponents/TailwindLayout";
import TopBar from "TailwindcssComponents/TopBar";
import FooterTailwind from "TailwindcssComponents/Footer";
import SeatViewModel from "./Models/seatViewModel";

export default function SingleEventZone() {
    const queryParams = new URLSearchParams(location.search);
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const bearerToken = localStorage.getItem('token');
    const { userData, selectedOrganization } = useContext(UserDataContext);
    const userRole = userData?.isAdmin ? 'admin' : selectedOrganization?.name || 'user';
    const { id } = useParams();
    const [seatsData, setSeatsData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [zoneData, setZoneData] = useState([]);
    const [seatViewModelOpen, setSeatViewModelOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchSeatsData();
        fetchZoneData();
    }, []);

    const fetchZoneData = async () => {
        try {
            const response = await axios.get(`${apiUrl}event-service/venue-zone/${id}`);
            if (response.data?.success) {
                setZoneData(response.data?.data);
            } else throw new Error(response.data?.message || 'Error in fetching venues');
        } catch (error) {
            console.error(error.response?.data?.message || error.message);
        }
    };

    const fetchSeatsData = async () => {
        try {
            const response = await axios.get(`${apiUrl}event-service/venue-seat`, { params: { zoneId: id } });
            if (response.data?.success) {
                setSeatsData(response.data?.data);
            } else throw new Error(response.data?.message || 'Error in fetching seats');
        } catch (error) {
            console.error(error.response?.data?.message || error.message);
        }
    };

    const openSeatViewModel = () => {
        setSeatViewModelOpen(true);
    }

    const closeSeatViewModel = () => {
        setSeatViewModelOpen(false);
    };

    return (
        <TailwindLayout>
            <TopBar />
            <div className="max-w-7xl mx-auto p-4 md:p-6 lg:p-12 mb-8 min-h-screen">
                <div className="relative bg-white rounded-lg shadow-md p-4 md:p-6">
                    {zoneData && (
                        <>
                            <div className="flex justify-between items-center mb-4">
                                <h2 className="text-xl font-bold">{zoneData.name}</h2>
                                {userRole === 'admin' && (
                                    <div className="flex gap-2">
                                        <button
                                            disabled={userRole !== 'admin'}
                                            onClick={() => navigate(`/venues/single-venue/edit-zone/${id}`)}
                                            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                                        >
                                            Edit
                                        </button>
                                        {zoneData.isSeat && (
                                            <button
                                                disabled={userRole !== 'admin'}
                                                onClick={openSeatViewModel}
                                                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                                            >
                                                View Seat Layout
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>

                            <div className="flex flex-col mb-4 border-t pt-4">
                                <p className="text-gray-700 mb-1">Capacity: {zoneData.capacity}</p>
                                <p className="text-gray-700 mb-1">Seats Layout: {zoneData.isSeat ? 'Yes' : 'No'}</p>
                                {zoneData.isSeat && (
                                    <>
                                        <p className="text-gray-700 mb-1">Total Rows: {zoneData.totalRows}</p>
                                        <p className="text-gray-700 mb-1">Total Seats Per Row: {zoneData.totalSeatsPerRows}</p>
                                    </>
                                )}
                            </div>
                        </>
                    )}
                </div>
            </div>

            <SeatViewModel
                open={seatViewModelOpen}
                onClose={closeSeatViewModel}
                seatData={seatsData}
            />
            <FooterTailwind />
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </TailwindLayout>
    );
}